module.exports = __webpack_public_path__ + "static/media/terms-and-conditions-en.cd3d129e.pdf";